{
	"dropzoneTitle": "Glissez et déposez le fichier ici",
	"dropzoneSubtitle": "ou cliquez pour sélectionner le fichier",
	"fileDetails": "Type de fichier : {{fileType}} jusqu'à {{fileSize}}",
	"downloadSample": "Télécharger le tableau exemple",
	"downloadInvalidSheet": "Télécharger le tableau avec erreurs",
	"errorImporting": "Impossible d'importer le tableau",
	"errorInvalidHeader": "Les colonnes du tableau ne correspondent pas au modèle attendu. Téléchargez un nouveau modèle et réessayez.",
	"errorUnreadableFile": "Impossible de lire le fichier. Vérifiez qu'il s'agit d'un fichier .xlsx valide et non corrompu.",
	"errorEmptySheet": "Le tableau est vide.",
	"errorEmptyHeaderCell": "Une colonne n'a pas de titre dans l'en-tête. Utilisez le modèle par défaut et ne laissez aucune colonne sans nom.",
	"selectFile": "Sélectionner un fichier",
	"selectAnotherFile": "Sélectionner un autre fichier",
	"invalidFileTitle": "Le fichier sélectionné n'est pas valide",
	"invalidFileReasonInvalidType": "Type de fichier non pris en charge. Utilisez des fichiers {{formats}}.",
	"invalidFileReasonTooLarge": "Le fichier dépasse la taille maximale de {{maxSize}}.",
	"invalidFileReasonTooManyFiles": "Un seul fichier ({{maxFiles}}) peut être importé à la fois.",
	"invalidFileReasonTooSmall": "Le fichier est plus petit que la taille autorisée.",
	"invalidFileReasonDefault": "Le fichier ne peut pas être importé. Vérifiez les exigences et réessayez.",
	"confirmCloseDialog": {
		"title": "Quitter l'importation en masse",
		"description": "Êtes-vous sûr de vouloir quitter l'importation en masse sans télécharger le tableau d'erreurs ?",
		"descriptionStrong": "Vous ne pourrez pas le télécharger à nouveau et perdrez cette information.",
		"cancel": "Quitter l'édition",
		"download": "Télécharger le tableau d'erreurs"
	},
	"importNewFile": "Importer un nouveau fichier"
}
